"use client";
import { Button, Col, Row, Form, Input ,message} from "antd";
import _ from "lodash";
import styles from "./index.module.scss";
import { RightOutlined } from "@ant-design/icons";
import lastServicePicOther from "@/assets/images/about/lastServicePicOther.png";
import lastServicePicOther01 from "@/assets/images/about/lastServicePicOther_1.png";
import { map } from "lodash";
import {registerSuccessUrl} from "@/constants/api";
import { formFieldList} from "@/constants/about";
import { registerService } from "@/services/register";
import { useRouter } from "next/navigation";
export default function LastServiceOther({
  titList01,
  buttonText = "获取专属方案",
  btnLink = registerSuccessUrl,
  title = "360智语信创门户解决方案"
}: {
  titList01?: string[];
  buttonText?: string;
  btnLink?: string;
  title?:string;
}) {
  const router = useRouter()
  const handleSubmit =async (values) => {
    const res = await registerService(values);
    if (_.get(res, "code") === "10000") {
      message.success(_.get(res, "msg") || "提交成功");
      router.push(btnLink)

    } else {
      message.error(_.get(res, "msg"));
    }
    
  };
  return (
    <div className={styles.lastServiceother}>
      <div className="wrapper hCenter">
        <Row align={"middle"}>
          <Col lg={12} xs={24} sm={24} md={24}>
            <div className={styles.leftCont}>
              <div className={styles.titleWrapper}>
                {titList01 && titList01.length > 0 ? (
                  map(titList01, (title) => {
                    return <h6>{title}</h6>;
                  })
                ) : (
                  <div>
                  <h6 className="mb40">{title}</h6>
                  <Form
                    name="basic"
                    wrapperCol={{ span: 12 }}
                    initialValues={{ remember: true }}
                    onFinish={handleSubmit}
                    //onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    labelCol={{ flex: "100px" }}
                    labelAlign="left"
                  >
                    {formFieldList.map((field: any, k: number) => {
                      return (
                        <div className={styles.customItem} key={k}>
                          <Form.Item
                            {...field.itemProps}
                            colon={false}
                            labelAlign="left"
                          >
                            <Input {...field.compProps} />
                          </Form.Item>
                        </div>
                      );
                    })}

                    <Button
                      type="primary"
                      className={styles.soonUseBtn}
                      htmlType="submit"
                    >
                      {buttonText}
                    </Button>
                  </Form>
                  </div>
                )}
              </div>
              <div>
              <img src={lastServicePicOther01.src} className={styles.pic01}/>
              </div>      
            </div>
          </Col>
          <Col lg={12} xs={24} sm={24} md={24}>
            <img src={lastServicePicOther.src} className={styles.pic} />
          </Col>
        </Row>
      </div>
    </div>
  );
}
